export default {"src":"/_next/static/media/GrowthMindset.19379ad0.svg","height":160,"width":160,"blurWidth":0,"blurHeight":0};